import type { AtomFamily } from 'jotai-family';

/**
 * Clears all cached atoms from an atomFamily to prevent memory leaks.
 * Should be called on component unmount when using atomFamily with unbounded params.
 * @see https://github.com/jotaijs/jotai-family?tab=readme-ov-file#caveat-memory-leaks
 */
export function clearAtomFamily<P, A>(family: AtomFamily<P, A>): void {
  for (const param of family.getParams()) {
    family.remove(param);
  }
}
